import React from 'react';
import { ArrowRight, Gift, Users, Sparkles, Award, Truck } from 'lucide-react';

export default function Hero({ isDark }) {
  return (
    <section
      id='home'
      className='relative min-h-screen flex items-center justify-center px-4 pt-20'
    >
      <div
        className={`absolute inset-0 ${
          isDark
            ? 'bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900'
            : 'bg-gradient-to-br from-orange-100 via-amber-50 to-rose-100'
        }`}
      >
        <div className='absolute inset-0 opacity-20'>
          <div className='absolute top-20 left-10 w-32 h-32 bg-orange-300 rounded-full blur-3xl animate-pulse'></div>
          <div className='absolute bottom-20 right-10 w-40 h-40 bg-pink-300 rounded-full blur-3xl animate-pulse delay-1000'></div>
          <div className='absolute top-1/2 left-1/2 w-20 h-20 bg-yellow-300 rounded-full blur-2xl animate-pulse delay-500'></div>
        </div>
      </div>

      <div className='relative z-10 text-center max-w-6xl mx-auto'>
        <div className='mb-8'>
          <span
            className={`inline-block px-6 py-3 rounded-full font-semibold border-2 transition-all duration-300 ${
              isDark
                ? 'bg-gray-800/60 border-orange-400 text-orange-400'
                : 'bg-white/60 border-orange-500 text-orange-600'
            } backdrop-blur-sm`}
          >
            🏆 Найкращі свічки України
          </span>
        </div>

        <h1 className='text-6xl md:text-8xl font-black mb-6 leading-tight'>
          <span
            className={`block ${
              isDark
                ? 'text-white'
                : 'bg-gradient-to-r from-orange-600 via-red-500 to-pink-600 bg-clip-text text-transparent'
            }`}
          >
            Світло
          </span>
          <span className='block bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 bg-clip-text text-transparent'>
            Душі
          </span>
        </h1>

        <p
          className={`text-xl md:text-2xl mb-12 max-w-3xl mx-auto leading-relaxed ${
            isDark ? 'text-gray-300' : 'text-gray-600'
          }`}
        >
          Унікальні ароматичні свічки ручної роботи з натуральних матеріалів.
          Створюємо атмосферу затишку та романтики у вашому домі.
        </p>

        <div className='flex flex-col sm:flex-row gap-6 justify-center mb-16'>
          <a href='#products' className='btn-primary group relative'>
            <span className='relative z-10 flex items-center justify-center'>
              Переглянути каталог
              <ArrowRight className='ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform' />
            </span>
          </a>
          <button
            className={`btn-outline ${
              isDark ? 'border-white/30 text-white hover:bg-white/10' : ''
            }`}
          >
            <span className='flex items-center justify-center'>
              <Gift className='mr-2 w-5 h-5' />
              Подарункові набори
            </span>
          </button>
        </div>

        <div className='grid grid-cols-2 md:grid-cols-4 gap-6'>
          {[
            { value: '2500+', label: 'Задоволених клієнтів', icon: Users },
            { value: '50+', label: 'Унікальних ароматів', icon: Sparkles },
            { value: '99%', label: 'Позитивних відгуків', icon: Award },
            { value: '24/7', label: 'Доставка по Україні', icon: Truck },
          ].map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div key={index} className='group'>
                <div
                  className={`${
                    isDark
                      ? 'bg-gray-800/60 border-gray-700'
                      : 'bg-white/60 border-orange-200'
                  } backdrop-blur-sm border rounded-xl p-4 text-center transition-all duration-300 group-hover:scale-105`}
                >
                  <Icon
                    className={`w-8 h-8 mx-auto mb-2 ${
                      isDark ? 'text-orange-400' : 'text-orange-500'
                    } group-hover:scale-110 transition-transform`}
                  />
                  <div
                    className={`text-2xl font-bold mb-1 ${
                      isDark ? 'text-white' : 'text-gray-800'
                    }`}
                  >
                    {stat.value}
                  </div>
                  <div
                    className={`text-sm ${
                      isDark ? 'text-gray-400' : 'text-gray-600'
                    }`}
                  >
                    {stat.label}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
